import { render, staticRenderFns } from "./openScheme.vue?vue&type=template&id=1d106157&scoped=true&"
import script from "./openScheme.vue?vue&type=script&lang=js&"
export * from "./openScheme.vue?vue&type=script&lang=js&"
import style0 from "./openScheme.vue?vue&type=style&index=0&id=1d106157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d106157",
  null
  
)

export default component.exports